var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"topuser"},_vm._l((_vm.topuser),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.changeModel({
          isShow: true,
          name: item.name,
          desc1: item.desc1,
          desc2: item.desc2,
          desc3: item.desc3,
          title: item.title
        })}}},[_c('div',{staticClass:"cover",style:(("backgroundImage:url(" + (item.cover) + ")"))}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.changeModel({
          isShow: true,
          name: item.name,
          desc1: item.desc1,
          desc2: item.desc2,
          desc3: item.desc3,
          title: item.title
        })}}},[_c('div',{staticClass:"cover",style:(("backgroundImage:url(" + (item.cover) + ")"))}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(item.name))])])}),_vm._v(" "),_vm._m(1)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('h4',[_vm._v("投资团队")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"cover mydefault"}),_vm._v(" "),_c('h4',[_vm._v("期待您的加入")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f7203f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/h5/team.vue
// module id = null
// module chunks = 